import { Box, Button, Typography } from "@mui/material";
import loadDistributionDiagramImage from "app/assets/load-distribution-diagram.png";
import clsx from "clsx";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLoadDistributionForm } from "../../../redux/selector";
import {
  LOAD_DISTRIBUTION_DIAGRAM_METRICS,
  LOAD_DISTRIBUTION_DIAGRAM_TITLE,
  LOAD_DISTRIBUTION_FORM_I18N_PREFIX,
  LOAD_DISTRIBUTION_RESULTS_FOOTER_ROWS,
  LOAD_DISTRIBUTION_RESULTS_ROWS,
  LOAD_DISTRIBUTION_RESULTS_TITLE,
  LOAD_DISTRIBUTION_VEHICLE_OK_LABEL,
} from "../data";
import { useStyles } from "./styles";

const formatMetricValue = (value: string) => {
  const numeric = Number(value.replace(/,/g, ""));

  if (Number.isNaN(numeric)) {
    return value;
  }

  return numeric.toLocaleString();
};

const Diagram = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const formValues = useSelector(selectLoadDistributionForm);

  const wheelbase = formatMetricValue(formValues?.axleDistanceCalculation ?? "6450");
  const centerOfGravity = formatMetricValue(formValues?.centerOfGravityCalculation ?? "860");

  return (
    <Box className={styles.diagramSection}>
      <Box className={styles.diagramHeader}>
        <Typography className={styles.diagramTitle}>
          {t(LOAD_DISTRIBUTION_DIAGRAM_TITLE)}
        </Typography>
        <Typography className={styles.diagramMetrics}>
          {t(LOAD_DISTRIBUTION_DIAGRAM_METRICS, {
            wb: wheelbase,
            cog: centerOfGravity,
          })}
        </Typography>
      </Box>

      <Box className={styles.diagramContent}>
        <Box className={styles.diagramImageWrapper}>
          <img
            src={loadDistributionDiagramImage}
            alt={t(`${LOAD_DISTRIBUTION_FORM_I18N_PREFIX}.DIAGRAM.DIAGRAM_ALT`)}
            className={styles.diagramImage}
          />
        </Box>

        <Box className={styles.resultsPanel}>
          <Typography className={styles.resultsHeader}>
            {t(LOAD_DISTRIBUTION_RESULTS_TITLE)}
          </Typography>

          {LOAD_DISTRIBUTION_RESULTS_ROWS.map((row, index) => (
            <Box
              key={row.labelKey}
              className={clsx(
                styles.resultRow,
                ((index + 1) % 3 === 0 ||
                  index === LOAD_DISTRIBUTION_RESULTS_ROWS.length - 1) &&
                  styles.resultRowDivider
              )}
            >
              <Typography className={styles.resultLabel} component="div">
                <span className={styles.resultLabelText}>{t(row.labelKey)}</span>
                <span className={styles.resultLabelColon}>:</span>
              </Typography>
              <Typography className={styles.resultValue}>{row.value}</Typography>
            </Box>
          ))}

          <Box className={styles.statusButtonWrapper}>
            <Button className={styles.statusButton} variant="contained" color="primary">
              {t(LOAD_DISTRIBUTION_VEHICLE_OK_LABEL)}
            </Button>
          </Box>

          {LOAD_DISTRIBUTION_RESULTS_FOOTER_ROWS.map((row) => (
            <Box key={row.labelKey} className={styles.resultRow}>
              <Typography className={styles.resultLabel} component="div">
                <span className={styles.resultLabelText}>{t(row.labelKey)}</span>
                <span className={styles.resultLabelColon}>:</span>
              </Typography>
              <Typography className={styles.resultValue}>{row.value}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Diagram;
